import type React from "react";
import { useShipperContractCreatProps } from "./fetch";
import { MasterDataVehicleDetailPageUi } from "./ui";

export const MasterDataVehicleDetailPage: React.FC<{
  vehicleIdStr: string | undefined;
}> = (params) => {
  const props = useShipperContractCreatProps(params.vehicleIdStr);
  return <MasterDataVehicleDetailPageUi {...props} />;
};
